import { Component, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/app.reducer";
import { GetMyDocuments, SearchDocuments } from "src/app/features/home/resources/_store/resources.actions";
import { debounceTime, takeUntil } from "rxjs/operators";
import { NotificationsService } from "angular2-notifications";
import { Subject } from "rxjs";
import { PAGE_LIMIT } from 'src/app/app.constants';


@Component({
  selector: 'all-documents-dialog',
  styleUrls: ['./all-documents-dialog.component.scss'],
  templateUrl: './all-documents-dialog.component.html'
})

export class AllDocumentsDialogComponent implements OnDestroy{
  documentList;
  filteredDocuments;
  searchInput = new FormControl();
  existingAttachments: Array<string> = [];
  myFilesPageNumber: number = 1;
  searchString: string = '';
  totalPagesInsearchResult: number = 0;
  stopper$: Subject<any> =new Subject();

  count;
  pageLimit = '10';

  limitPerPageOptions;

  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: NotificationsService,
  ) {
    this.dialogRef.disableClose = true;
    this.existingAttachments = (this.data || {}).attachments || [];
  }

  ngOnInit() {
    this.limitPerPageOptions = PAGE_LIMIT;

    this.store.dispatch(new SearchDocuments(this.searchString, { page: 1, limit:  this.pageLimit }));

    // this.store.select(state => state.resources.myDocuments).subscribe((docList: any) => {
    //   this.documentList = docList;
    // });
    this.store.select(state => state.resources.docSearchResults).pipe(takeUntil(this.stopper$)).subscribe((docsList: any) => {
      if (Object.keys(docsList).length) {

        console.log(docsList);
        

        this.documentList = docsList.docs;
        this.myFilesPageNumber = docsList.page;
        this.totalPagesInsearchResult = docsList.pages;
        this.count = docsList.total;

      }
    })

    /* listening to search input */
    this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
      if (searchString !== null) {
        this.searchString = searchString;
        this.store.dispatch(new SearchDocuments(searchString.trim(), { page: 1, limit: 10 }));
      }
    });
  }

  onClickingDocument(documentObj) {

    
    if (documentObj != undefined) {
      const docId = (documentObj.document || {})._id ? (documentObj.document || {})._id : (documentObj.document || {}).id;
      if (this.existingAttachments.includes(docId)) {
        this.notificationService.info("Selected document is already attached");
      } else {
        this.dialogRef.close(documentObj.document);
      }
    }
  }

  onScrollDocsDialog(event) {
    const divViewHeight = event.target.offsetHeight; // viewport: ~500px
    const divScrollHeight = event.target.scrollHeight; // length of all table
    const scrollLocation = event.target.scrollTop; // how far user scrolled
    const limit = divScrollHeight - divViewHeight;

    if (scrollLocation >= limit) {
      if (this.myFilesPageNumber < this.totalPagesInsearchResult) {
        ++this.myFilesPageNumber;
      this.store.dispatch(new SearchDocuments(this.searchString, { page: this.myFilesPageNumber, limit:  this.pageLimit }))
      }

    }
  }


   
  getServerData(event) {
    console.log(event);
    this.store.dispatch(new SearchDocuments(this.searchString, { page: event, limit:  this.pageLimit }));
  }


  onChange(event){
    this.pageLimit = event.value;
    this.store.dispatch(new SearchDocuments(this.searchString, { page: 1, limit:  this.pageLimit }));

  }



  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnDestroy() {
    this.stopper$.next();
  }
}